/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { TimeSpanFromJSON, TimeSpanToJSON, } from './';
export function TimeZoneInfoFromJSON(json) {
    return TimeZoneInfoFromJSONTyped(json, false);
}
export function TimeZoneInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'hasIanaId': !exists(json, 'hasIanaId') ? undefined : json['hasIanaId'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'standardName': !exists(json, 'standardName') ? undefined : json['standardName'],
        'daylightName': !exists(json, 'daylightName') ? undefined : json['daylightName'],
        'baseUtcOffset': !exists(json, 'baseUtcOffset') ? undefined : TimeSpanFromJSON(json['baseUtcOffset']),
        'supportsDaylightSavingTime': !exists(json, 'supportsDaylightSavingTime') ? undefined : json['supportsDaylightSavingTime'],
    };
}
export function TimeZoneInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'baseUtcOffset': TimeSpanToJSON(value.baseUtcOffset),
    };
}
